import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import sellersData from "../../../Data/sellercards.json";
import profile from "../../../../assests/user.png";
import AddIcon from "@mui/icons-material/Add";

const SellerCards = () => {
  const [sellers, setSellers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [optionValue, setOptionValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const sellersPerPage = 8;

  useEffect(() => {
    setSellers(sellersData);
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const handleOptionChange = (event) => {
    setOptionValue(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const filteredSellers = sellers.filter((seller) =>
    seller.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastSeller = currentPage * sellersPerPage;
  const indexOfFirstSeller = indexOfLastSeller - sellersPerPage;
  const currentSellers = filteredSellers.slice(
    indexOfFirstSeller,
    indexOfLastSeller
  );

  return (
    <Box sx={{ padding: 2, backgroundColor: "#f3f5f9", minHeight: "100vh" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h4">Sellers Cards</Typography>
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          sx={{
            backgroundColor: "#3bb77e",
            "&:hover": { backgroundColor: "#36a574" },
          }}
        >
          Create New
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <TextField
          label="Search..."
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          sx={{ width: { xs: "100%", sm: "200px", md: "250px" } }}
        />
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Show 20</InputLabel>
            <Select
              value={dropdownValue}
              onChange={handleDropdownChange}
              label="Dropdown 1"
            >
              <MenuItem value="option1">Option 1</MenuItem>
              <MenuItem value="option2">Option 2</MenuItem>
              <MenuItem value="option3">Option 3</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={optionValue}
              onChange={handleOptionChange}
              label="Dropdown 2"
            >
              <MenuItem value="optionA">Pending</MenuItem>
              <MenuItem value="optionB">Fullfilled</MenuItem>
              <MenuItem value="optionC">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650,backgroundColor: "#f3f5f9", minHeight: "100vh" }} aria-label="seller table">
          <TableHead sx={{ backgroundColor: "#f7f8f9" }}>
            <TableRow>
              <TableCell align="center">Profile</TableCell>
              <TableCell align="center">Seller ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentSellers.map((seller) => (
              <TableRow key={seller.id}>
                <TableCell align="center">
                  <img
                    src={profile}
                    alt="Profile"
                    style={{ width: "50px", height: "auto" }}
                  />
                </TableCell>
                <TableCell align="center">{seller.id}</TableCell>
                <TableCell align="center">{seller.name}</TableCell>
                <TableCell align="center">{seller.email}</TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#3bb77e",
                      color: "#fff",
                      "&:hover": { backgroundColor: "#36a574" },
                      width: { xs: "100%", sm: "auto" },
                      padding: { xs: "8px", sm: "10px 16px" },
                    }}
                  >
                    View details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        mt={2}
      >
        <Pagination
          count={Math.ceil(filteredSellers.length / sellersPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          sx={{
            "& .MuiPaginationItem-root": {
              backgroundColor: "transparent",
              borderRadius: 0,
              color: "black",
              "&:hover": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected": {
                backgroundColor: "#3bb77e",
                color: "#fff",
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default SellerCards;
